import PropTypes from 'prop-types';
import React, { createContext } from 'react';
import { markup } from 'config/markup';

export const MarkupContext = createContext();

export const MarkupProvider = ({ children }) => {
  return (
    <MarkupContext.Provider value={markup}>{children}</MarkupContext.Provider>
  );
};

MarkupProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
